import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, { ReactElement, useMemo } from 'react';

import { gridCellDisplayName } from '../GridCell/GridCell.qa';
import { getValueOrDefault, getVisibilityClass } from '../shared/GridUtils/GridUtils';

export interface IGridRowProps extends IPropsWithChildren {
    className?: string;
    'data-testid'?: string;

    hide?: boolean;
    smHide?: boolean;
    mdHide?: boolean;
    lgHide?: boolean;

    show?: boolean;
    smShow?: boolean;
    mdShow?: boolean;
    lgShow?: boolean;
}

export function OzGridRow (props: IGridRowProps): ReactElement {
    const {
        className = '',
        'data-testid': dataTestId,
        children,

        show,
        smShow,
        mdShow,
        lgShow,

        hide,
        smHide,
        mdHide,
        lgHide,
    }: IGridRowProps = props;

    const styles: { [key: string]: string } = {
        'sm-hide': 'hidden',
        'sm-show': 'block',
        'md-hide': 'md:hidden',
        'md-show': 'md:block',
        'lg-hide': 'lg:hidden',
        'lg-show': 'lg:block',
    };

    const rowClassNames: string = useMemo((): string => {
        return (classNames([
            className,
            'w-full p-0 flex flex-wrap',

            getVisibilityClass('sm', 'hide', getValueOrDefault(smHide, hide), styles),
            getVisibilityClass('md', 'hide', getValueOrDefault(mdHide, hide), styles),
            getVisibilityClass('lg', 'hide', getValueOrDefault(lgHide, hide), styles),

            getVisibilityClass('sm', 'show', getValueOrDefault(smShow, show), styles),
            getVisibilityClass('md', 'show', getValueOrDefault(mdShow, show), styles),
            getVisibilityClass('lg', 'show', getValueOrDefault(lgShow, show), styles),
        ]));
    }, [
        className,

        show,
        smShow,
        mdShow,
        lgShow,

        hide,
        smHide,
        mdHide,
        lgHide,
    ]);

    return (
        <div className={rowClassNames} data-testid={dataTestId}>{children}</div>
    );
}

OzGridRow.displayName = gridCellDisplayName;
